import React from "react";
import Modal, { ModalProps } from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";

import "./GemExpiringModal.scss";
import FilledButton from "../../FilledButton/FilledButton";
import Gem from "../../../Gem/Gem";
import ImageHourglass from "../../../../images/hourglass.svg";
import ImageWarning from "../../../../images/warning-alert-circle-orange.svg";

interface GemExpiringModalProps extends ModalProps {
  daysToExpire: string;
}

function GemExpiringModal({
  daysToExpire,
  onHide,
  ...restProps
}: GemExpiringModalProps) {
  return (
    <Modal
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="gem-expiring-modal"
      {...restProps}
    >
      <div className="MobileOnly info-modal-content">
        <Modal.Body className="modal-content">
          <p className="text-center">
            <Image
              src={ImageHourglass}
              alt="hourglass"
              height={105}
              width={105}
            />
          </p>
          <h2>GEM expiring soon</h2>
          <p className="explainer">
            Your GEM expires in <strong>{daysToExpire}.</strong> Play a game to
            keep your <Gem width={16} height={14} />
            GEM.
          </p>
          <p role="alert" className="warning">
            <Image src={ImageWarning} alt="warning" width={11} height={11} />
            <span>You'll lose all your GEM if it expires.</span>
          </p>
          <FilledButton onClick={onHide} style={{ height: 52 }}>
            Close
          </FilledButton>
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default GemExpiringModal;
